<template>
  <div class="home">
    <div class="hero">
      <div class="contain">
        <div class="text">
          <h1>Loans for those who need it most.</h1>
          <router-link to="/application" class="btn"
            >See your options</router-link
          >
        </div>
        <img src="@/assets/img/hero_img.png" />
      </div>
    </div>

    <div class="contain">
      <h2>
        It’s easy with Equfi
        <span class="dot">.</span>
      </h2>
      <div class="icons">
        <div class="icon">
          <img src="@/assets/img/icon.svg" />
          <h3>Answer a few questions</h3>
          <p>
            Give us some details on the kind of loan you need and how you’ll use
            it. We’ll send your request out to our lender network, and within
            seconds, you’ll see competing offers.
          </p>
        </div>
        <div class="icon">
          <img src="@/assets/img/icon.svg" />
          <h3>Answer a few questions</h3>
          <p>
            Give us some details on the kind of loan you need and how you’ll use
            it. We’ll send your request out to our lender network, and within
            seconds, you’ll see competing offers.
          </p>
        </div>
        <div class="icon">
          <img src="@/assets/img/icon.svg" />
          <h3>Answer a few questions</h3>
          <p>
            Give us some details on the kind of loan you need and how you’ll use
            it. We’ll send your request out to our lender network, and within
            seconds, you’ll see competing offers.
          </p>
        </div>
      </div>

      <div class="btns center">
        <router-link to="/application" class="btn">Get Started</router-link>
      </div>
    </div>

    <div class="blue-background">
      <div class="contain split-info">
        <div class="left">
          <p class="large">
            We Love Small Business
            <span class="dot">.</span>
          </p>
          <p>
            Give us some details on the kind of loan you need and how you’ll use
            it. We’ll send your request out to our lender network, and within
            seconds, you’ll see competing offers.
          </p>
        </div>
        <div class="right">
          <div class="icons">
            <div class="icon">
              <img src="@/assets/img/icon.svg" />
              <p class="stat">100+</p>
              <p>Small Businesses helped.</p>
            </div>
            <div class="icon">
              <img src="@/assets/img/icon.svg" />
              <p class="stat">$1 Million+</p>
              <p>Secured Through Equfi.</p>
            </div>
          </div>

          <div class="btns left">
            <router-link to="/application" class="btn">Get Started</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="contain">
      <div class="center">
        <img src="@/assets/img/icon.svg" />
        <h2>
          Calculate your Loan options
          <span class="dot">.</span>
        </h2>
        <p>
          Give us some details on the kind of loan you need and how you’ll use
          it. We’ll send your request out to our lender network, and within
          seconds, you’ll see competing offers.
        </p>
      </div>
    </div>

    <div class="cta">
      <div class="contain">
        <router-link to="/application" class="btn reverse"
          >Get Started</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions } from "@/config/firebaseInit";

export default {
  name: "home",
  data() {
    return {};
  },
  // firestore() {
  //   return {
  //     data: db.collection("data")
  //   };
  // },
  mounted() {},
  created() {
    if (!this.$store.state.clear) {
      localStorage.clear();
      this.$store.commit("stopClear");
      window.location.reload();
    }
  },
  updated() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.hero {
  height: auto;
  min-height: 600px;
  background: rgba(11, 110, 251, 0.08);
  overflow: hidden;
  .contain {
    height: auto;
    min-height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    .text {
      display: flex;
      height: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    h1 {
      font-size: 60px;
      text-align: center;
      max-width: 700px;
      margin: auto;
      margin-top: 50px;
      margin-bottom: 50px;
      @media screen and (max-width: 700px) {
        font-size: 40px;
        margin-bottom: 30px;
      }
    }
    .btn {
      margin-bottom: 50px;
    }
    img {
      @media screen and (max-width: 700px) {
        width: 100%;
      }
    }
    padding-bottom: 0;
  }
}

.split-info {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  & > div {
    width: 45%;
    @media screen and (max-width: 700px) {
      width: 100%;
    }
  }
  .left {
    @media screen and (max-width: 700px) {
      margin-bottom: 50px;
    }
    p {
      margin-bottom: 0;
    }
    .large {
      font-weight: bold;
      font-size: 70px;
      word-wrap: wrap;
      margin: 0;
      line-height: 1.2;
      margin-bottom: 50px;
      @media screen and (max-width: 700px) {
        font-size: 50px;
      }
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-wrap: wrap;
    .icons {
      display: flex;
      @media screen and (max-width: 500px) {
        margin-bottom: 0;
      }
      .icon {
        width: 47%;
        @media screen and (max-width: 500px) {
          width: 100%;
        }
        p {
          color: #0b6efb;
          margin: 0;
        }
        .stat {
          font-weight: bold;
          margin: 0;
          font-size: 25px;
          margin-bottom: 10px;
        }
      }
    }
  }
}

.center {
  max-width: 700px;
  margin: auto;
  img {
    height: 150px;
    margin-bottom: 30px;
    @media screen and (max-width: 700px) {
      height: 100px;
    }
  }
}
</style>
